import types from './actionTypes'

export const loginWithToken = token => ({
  type: types.AUTH_LOGIN,
  data: {
    method: 'sso',
    token: token
  }
})

export const loginWithLegacy = data => ({
  type: types.AUTH_SELECT_ACCOUNT,
  data: data
})

export const loginWithUsername = (username, password) => ({
  type: types.AUTH_LOGIN,
  data: {
    method: 'legacy',
    username,
    password
  }
})

export const selectAccount = (data, ssoToken) => {
  return {
    type: types.AUTH_LOAD_LOGIN_PROFILE,
    data: {
      account: data,
      ssoToken: ssoToken
    }
  }
}

export const refreshUserProfile = () => ({
  type: types.AUTH_REFRESH_PROFILE
})

export const logout = () => {
  localStorage.clear()
  
  return {
    type: types.AUTH_LOGOUT  
  }
}

export default {
  loginWithToken,
  loginWithUsername,
  loginWithLegacy,
  selectAccount,
  refreshUserProfile,
  logout
}



// WEBPACK FOOTER //
// ./src/containers/Auth/store/actions.js